var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { "no-gutters": "" } },
    [
      _c(
        "v-navigation-drawer",
        {
          attrs: {
            "mini-variant": _vm.mini,
            permanent: "",
            app: "",
            stateless: "",
            fixed: "",
            "hide-overlays": "",
            width: 215,
          },
          scopedSlots: _vm._u([
            {
              key: "append",
              fn: function () {
                return [
                  _c("v-list", { staticClass: "px-4", attrs: { dense: "" } }),
                  _c("v-divider", { staticClass: "mx-2 mt-n1" }),
                  _c(
                    "v-list",
                    { staticClass: "px-4 pt-0 mb-2", attrs: { dense: "" } },
                    [
                      _c(
                        "v-list-item",
                        {
                          staticClass: "mt-1",
                          attrs: {
                            ripple: false,
                            "active-class": "transparent",
                          },
                        },
                        [
                          _c(
                            "v-list-group",
                            {
                              key: _vm.mini,
                              attrs: {
                                value:
                                  !_vm.mini &&
                                  _vm.selectedIcon === "AuthSettings"
                                    ? true
                                    : false,
                                "active-class": "transparent green-500--text",
                                exact: "",
                                ripple: false,
                                "no-action": !!_vm.mini,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function () {
                                    return [
                                      _c(
                                        "v-list-item-icon",
                                        {
                                          staticClass: "mr-0",
                                          staticStyle: { width: "30px" },
                                        },
                                        [
                                          _c(
                                            "v-menu",
                                            {
                                              staticClass: "list-active-draw",
                                              attrs: {
                                                right: "",
                                                "close-delay": 100,
                                                "open-on-hover": true,
                                                "open-delay": 10,
                                                "nudge-right": 20,
                                                "offset-x": "",
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c("v-hover", {
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function ({
                                                                hover,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-row",
                                                                    {
                                                                      attrs: {
                                                                        align:
                                                                          "center",
                                                                        "no-gutters":
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "ml-1 icon-panel",
                                                                          attrs:
                                                                            {
                                                                              src: require(`@/assets/navigationdrawer-ax/account-icon${
                                                                                _vm.selectedIcon ===
                                                                                  "AuthSettings" ||
                                                                                hover
                                                                                  ? "-active"
                                                                                  : ""
                                                                              }.svg`),
                                                                              height: 16,
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "v-btn",
                                                                        _vm._g(
                                                                          _vm._b(
                                                                            {
                                                                              staticClass:
                                                                                "ml-5 pa-0",
                                                                              staticStyle:
                                                                                {
                                                                                  "z-index":
                                                                                    "100 !important",
                                                                                  position:
                                                                                    "absolute",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  text: "",
                                                                                },
                                                                            },
                                                                            "v-btn",
                                                                            attrs,
                                                                            false
                                                                          ),
                                                                          on
                                                                        ),
                                                                        [
                                                                          _vm.mini
                                                                            ? _c(
                                                                                "v-icon",
                                                                                {
                                                                                  staticClass:
                                                                                    "ml-1 btn-tooltip-panel",
                                                                                  attrs:
                                                                                    {
                                                                                      color:
                                                                                        hover
                                                                                          ? "green-500"
                                                                                          : `${
                                                                                              _vm.selectedIcon ===
                                                                                              "AuthSettings"
                                                                                                ? "green-500"
                                                                                                : "grey-700"
                                                                                            }`,
                                                                                      size: "16",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "mdi-dots-vertical"
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ]),
                                            },
                                            [
                                              _c(
                                                "v-list",
                                                { staticClass: "pa-0" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "px-3 mb-2 d-block grey-700--text subtitle-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Configuración de la cuenta"
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      staticClass: "px-3 mb-n1",
                                                      class:
                                                        _vm.selectedIcon ===
                                                        "AuthSettings"
                                                          ? "green-500--text "
                                                          : "text--grey-700",
                                                      attrs: {
                                                        "active-class":
                                                          "transparent",
                                                        to: {
                                                          name: "AuthSettings",
                                                          params:
                                                            _vm.currentParams,
                                                        },
                                                        ripple: false,
                                                        exact: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          _vm.selectedIcon =
                                                            "AuthSettings"
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        {
                                                          staticClass:
                                                            "body-2 font-weight-medium",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Configuración de la cuenta"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      staticClass: "px-3",
                                                      attrs: {
                                                        "active-class":
                                                          "transparent font-weight-black",
                                                        ripple: false,
                                                        exact: "",
                                                      },
                                                      on: {
                                                        click: _vm.deleteAuth,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        {
                                                          staticClass:
                                                            "body-2 font-weight-medium text--grey-700",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Cerrar sesión"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticClass: "pl-3 mr-n4",
                                          staticStyle: { "line-height": "3.5" },
                                        },
                                        [
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "d-inline-block subtitle-2 text-truncate",
                                                class:
                                                  _vm.selectedIcon ===
                                                  "AuthSettings"
                                                    ? "green-500--text font-weight-semibold"
                                                    : "grey-700--text font-weight-medium",
                                                staticStyle: {
                                                  "max-width": "120px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$store.state.auth
                                                      .userAccount.given_name ||
                                                      "Sin definir"
                                                  ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$store.state.auth
                                                        .userAccount.family_name
                                                    )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "mt-n4 d-block body-2 text-truncate",
                                                class:
                                                  _vm.selectedIcon ===
                                                  "AuthSettings"
                                                    ? "green-500--text "
                                                    : "grey-700--text",
                                                staticStyle: {
                                                  "max-width": "120px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$store.state.auth
                                                      .userAccount.email ||
                                                      "Sin definir"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                        ],
                                        2
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "py-0 pl-2 mt-4",
                                  class:
                                    _vm.selectedIcon === "AuthSettings"
                                      ? "green-500--text font-weight-semibold"
                                      : "grey-700--text font-weight-medium",
                                  attrs: {
                                    "active-class":
                                      "transparent font-weight-black",
                                    to: {
                                      name: "AuthSettings",
                                      params: _vm.currentParams,
                                    },
                                    ripple: false,
                                    exact: "",
                                  },
                                },
                                [
                                  _c("v-divider", { attrs: { vertical: "" } }),
                                  _c(
                                    "v-list-item-title",
                                    {
                                      staticClass:
                                        "body-1 font-weight-medium grey-500--text pl-3 pt-1`",
                                    },
                                    [_vm._v("Configuración de la cuenta")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "py-0 pl-2 grey-700--text",
                                  attrs: {
                                    "active-class":
                                      "transparent font-weight-black",
                                    ripple: false,
                                    exact: "",
                                  },
                                  on: { click: _vm.deleteAuth },
                                },
                                [
                                  _c("v-divider", { attrs: { vertical: "" } }),
                                  _c(
                                    "v-list-item-title",
                                    {
                                      staticClass:
                                        "body-1 font-weight-medium grey-500--text pl-3 pt-2",
                                    },
                                    [_vm._v("Cerrar sesión")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "v-list",
            { staticClass: "px-0 py-5" },
            [
              _c(
                "v-list-item",
                { staticClass: "px-4 py-0" },
                [
                  _c("img", {
                    staticClass: "ml-n1",
                    attrs: {
                      src: require(`@/assets/appAsset-brand--axteroid-icon${
                        _vm.$route.params.prefix ? `-test` : ""
                      }.svg`),
                    },
                  }),
                  _c("v-spacer"),
                ],
                1
              ),
              _c("v-divider", { staticClass: "mt-5 mx-3" }),
              _c(
                "v-list-item",
                { staticClass: "px-4 py-1" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-n4",
                      attrs: { small: "", text: "", ripple: false },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.mini = !_vm.mini
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require(`@/assets/navigationdrawer-ax/${
                            _vm.mini ? "open" : "close"
                          }-icon.svg`),
                          height: 17,
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
              !!_vm.$store.state.auth.account.acc_id
                ? [
                    _c("v-divider", { staticClass: "mt-0 mx-3" }),
                    _vm._l(
                      _vm.list.slice(0, _vm.list.length - 1),
                      function (link) {
                        return _c(
                          "v-list-item",
                          {
                            key: link.title,
                            staticClass: "px-3 py-1",
                            attrs: {
                              "active-class": "transparent",
                              exact: "",
                              link: "",
                              ripple: false,
                            },
                          },
                          [
                            link?.options?.length
                              ? _c(
                                  "v-list-group",
                                  {
                                    key: _vm.mini,
                                    staticClass: "ma-0",
                                    attrs: {
                                      value:
                                        !_vm.mini &&
                                        _vm.selectedIcon === link.link
                                          ? link.show
                                          : false,
                                      "active-class":
                                        "transparent green-500--text",
                                      "no-action": !!_vm.mini,
                                      exact: "",
                                      ripple: false,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function () {
                                            return [
                                              _c(
                                                "v-list-item-icon",
                                                {
                                                  staticClass: "mx-0",
                                                  staticStyle: {
                                                    width: "30px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-menu",
                                                    {
                                                      key: _vm.mini,
                                                      staticClass:
                                                        "list-active-draw",
                                                      attrs: {
                                                        right: "",
                                                        "close-delay": 100,
                                                        "open-on-hover": true,
                                                        "open-delay": 10,
                                                        "nudge-right": 20,
                                                        "offset-x": "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                              attrs,
                                                            }) {
                                                              return [
                                                                _c("v-hover", {
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "default",
                                                                          fn: function ({
                                                                            hover,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "v-row",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      align:
                                                                                        "center",
                                                                                      "no-gutters":
                                                                                        "",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-btn",
                                                                                    _vm._g(
                                                                                      _vm._b(
                                                                                        {
                                                                                          staticClass:
                                                                                            "pa-0",
                                                                                          staticStyle:
                                                                                            {
                                                                                              "z-index":
                                                                                                "100 !important",
                                                                                              position:
                                                                                                "absolute",
                                                                                            },
                                                                                          attrs:
                                                                                            {
                                                                                              text: "",
                                                                                            },
                                                                                        },
                                                                                        "v-btn",
                                                                                        attrs,
                                                                                        false
                                                                                      ),
                                                                                      _vm.mini
                                                                                        ? on
                                                                                        : false
                                                                                    ),
                                                                                    [
                                                                                      _c(
                                                                                        "img",
                                                                                        {
                                                                                          staticClass:
                                                                                            "ml-1 icon-panel",
                                                                                          attrs:
                                                                                            {
                                                                                              src: require(`@/assets/navigationdrawer-ax/${
                                                                                                link.icon
                                                                                              }-icon${
                                                                                                _vm.selectedIcon ===
                                                                                                  link.link ||
                                                                                                hover
                                                                                                  ? "-active"
                                                                                                  : _vm
                                                                                                      .$vuetify
                                                                                                      .theme
                                                                                                      .dark
                                                                                                  ? "-dark"
                                                                                                  : ""
                                                                                              }.svg`),
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                      _vm.mini
                                                                                        ? _c(
                                                                                            "v-icon",
                                                                                            {
                                                                                              key: _vm
                                                                                                .$route
                                                                                                .name,
                                                                                              staticClass:
                                                                                                "ml-1 btn-tooltip-panel",
                                                                                              attrs:
                                                                                                {
                                                                                                  color:
                                                                                                    hover
                                                                                                      ? "green-500"
                                                                                                      : `${
                                                                                                          _vm.selectedIcon ===
                                                                                                          link.link
                                                                                                            ? "green-500"
                                                                                                            : "grey-700"
                                                                                                        }`,
                                                                                                  size: "16",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                "mdi-dots-vertical"
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                }),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _c(
                                                        "v-list",
                                                        { staticClass: "pa-0" },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "px-3 mb-2 d-block grey-700--text subtitle-2 font-weight-medium",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  link.title
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            link.options,
                                                            function (option) {
                                                              return _c(
                                                                "v-list-item",
                                                                {
                                                                  key: option.link,
                                                                  staticClass:
                                                                    "px-3 mb-n1",
                                                                  attrs: {
                                                                    "active-class":
                                                                      "transparent",
                                                                    ripple: false,
                                                                    to: {
                                                                      name: option.link,
                                                                      params:
                                                                        _vm.currentParams,
                                                                    },
                                                                    exact: "",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    {
                                                                      staticClass:
                                                                        "body-2",
                                                                      class:
                                                                        _vm
                                                                          .$route
                                                                          .name ===
                                                                        option.link
                                                                          ? "green-500--text"
                                                                          : "text--grey-700",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          option.title
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item-title",
                                                {
                                                  staticClass:
                                                    "d-inline-block subtitle-2 text-truncate pl-4",
                                                  class:
                                                    _vm.selectedIcon ===
                                                    link.link
                                                      ? "green-500--text font-weight-semibold"
                                                      : "grey-700--text font-weight-medium",
                                                  staticStyle: {
                                                    width: "118px",
                                                    "line-height": "1.6",
                                                  },
                                                },
                                                [[_vm._v(_vm._s(link.title))]],
                                                2
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  _vm._l(link.options, function (option) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: option.link,
                                        staticClass: "pl-3 py-0",
                                        class:
                                          _vm.$route.name === option.link ||
                                          option.associatedRoutes.includes(
                                            _vm.$route.name
                                          )
                                            ? "green-500--text font-weight-semibold"
                                            : "grey-700--text font-weight-medium",
                                        attrs: {
                                          "active-class": "transparent",
                                          ripple: false,
                                          to: {
                                            name: option.link,
                                            params: _vm.currentParams,
                                          },
                                          exact: "",
                                        },
                                      },
                                      [
                                        _c("v-divider", {
                                          attrs: { vertical: "" },
                                        }),
                                        _c(
                                          "v-list-item-title",
                                          {
                                            staticClass: "pl-2 py-1",
                                            class:
                                              _vm.$route.name === option.link ||
                                              option.associatedRoutes.includes(
                                                _vm.$route.name
                                              )
                                                ? "green-500--text"
                                                : "grey-500--text",
                                          },
                                          [_vm._v(_vm._s(option.title))]
                                        ),
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                )
                              : [
                                  _c(
                                    "v-list-item",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: {
                                        to: {
                                          name: link.link,
                                          params: _vm.currentParams,
                                        },
                                        ripple: false,
                                        exact: "",
                                        "active-class":
                                          "transparent font-weight-black",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-icon",
                                        { staticClass: "mr-4 my-1" },
                                        [
                                          _c("v-hover", {
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ hover }) {
                                                    return [
                                                      _c("img", {
                                                        staticClass: "ml-1",
                                                        attrs: {
                                                          src: require(`@/assets/navigationdrawer-ax/${
                                                            link.icon
                                                          }-icon${
                                                            _vm.selectedIcon ===
                                                              link.link || hover
                                                              ? "-active"
                                                              : ""
                                                          }.svg`),
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticClass: "subtitle-2",
                                          class:
                                            _vm.selectedIcon === link.link
                                              ? "green-500--text font-weight-semibold"
                                              : "grey-700--text font-weight-medium",
                                          staticStyle: { "line-height": "1.5" },
                                        },
                                        [_vm._v(_vm._s(link.title))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                          ],
                          2
                        )
                      }
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }